module.exports = __webpack_public_path__ + "static/img/environment_05.8c3709d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_05.png
// module id = F4Mr
// module chunks = 34